import { useSuspenseQuery } from '@tanstack/react-query';
import type { User } from '../types';
import queryKeys from './queryKeys';
import type { QueryConfig } from 'lib/react-query';
import { apiClient } from 'lib/api';
import type { ListResponse, SortingParams } from 'types/shared';
import queryString from 'query-string';

interface GetUsersParams extends Partial<SortingParams> {
  email?: string;
  apps?: string[];
  limit?: number;
  offset?: number;
}

const getUsersDTO = (r: ListResponse<User>): ListResponse<User> => {
  return ({
    ...r,
    data: r?.data?.filter(u => u.username !== 'root') ?? [],
  });
};

export const getUsers = async (
  params?: GetUsersParams,
  signal?: AbortSignal,
): Promise<ListResponse<User>> => {
  const res = await apiClient.get<ListResponse<User>>(queryKeys.users, {
    params,
    signal,
    paramsSerializer: (prms) =>
      queryString.stringify(prms, { arrayFormat: 'comma' }),
  });
  return getUsersDTO(res.data);
};

interface UseUsersOptions<TData> {
  config?: QueryConfig<typeof getUsers, TData>;
  params?: GetUsersParams;
}

export const useUsers = <TData = ListResponse<User>>
({
   params,
   config,
 }: UseUsersOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getUsers(params, signal),
    queryKey: [queryKeys.users, params],
  });
};
